import { AnimatePresence } from "framer-motion"
import styled from "styled-components"
import {
  TableContainer,
  TableHeader,
  TableTitle,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ResponsiveTableWrapper,
  TooltipContainer,
  Tooltip,
} from "./styled/Table"




export const OrdersTable = ({ orders }) => {
  const tableVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        staggerChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      x: -100,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  }

  const rowVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100 },
    },
    hover: { scale: 1.01 },
  }

  const getStatusColor = (status) => {
    const colors = {
      pending: "#FFA500",
      processing: "#4A88F3",
      Aceptada: "#4CAF50",
      Rechazada: "#FF4444",
    }
    return colors[status]
  }

  const StatusBadge = styled.span`
    background: ${(props) => getStatusColor(props.status)};
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 768px) {
      padding: 4px 8px;
      font-size: 0.75rem;
    }
  `
  
  return (
    <TableContainer variants={tableVariants} initial="hidden" animate="visible" exit="exit">
      <TableHeader>
        <TableTitle>Pedidos</TableTitle>
      </TableHeader>
      <ResponsiveTableWrapper>
        <Table>
          <TableHead>
            <tr>
              <TableCell as="th">ORDEN #</TableCell>
              <TableCell as="th">CLIENTE</TableCell>
              <TableCell as="th">PRODUCTOS</TableCell>
              <TableCell as="th">TOTAL</TableCell>
              <TableCell as="th">ESTADO</TableCell>
              <TableCell as="th">FECHA</TableCell>
            </tr>
          </TableHead>
          <TableBody>
            <AnimatePresence>
              {orders?.map((order) => (
                <TableRow key={order.id} variants={rowVariants} whileHover="hover" layout>
                  <TableCell data-label="Orden #">{order?.norden}</TableCell>
                  <TableCell data-label="Cliente">
                      {order?.name}
                  </TableCell>
                  <TableCell data-label="Productos">
                        {order?.productos}
                  </TableCell>
                  <TableCell data-label="Total">
                    {new Intl.NumberFormat("es-CO", {
                      style: "currency",
                      currency: "COP",
                    }).format(order?.total)} 
                  </TableCell>
                  <TableCell data-label="Estado">
                    <StatusBadge status={order?.status === 1 ? "Rechazada" : "Aceptada"}>{order?.status === 1 ? "Rechazada" : "Aceptada"}</StatusBadge>
                  </TableCell>
                  <TableCell data-label="Fecha">{new Date(order?.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </AnimatePresence>
          </TableBody>
        </Table>
      </ResponsiveTableWrapper>
    </TableContainer>
  )
}

